import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
// Models
import { selectedValues } from '../logbooks-menu/logbooks-menu.component';
import { IonPopover, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-logbooks-time-filter',
  templateUrl: './logbooks-time-filter.component.html',
  styleUrls: ['./logbooks-time-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LogbooksTimeFilter  implements OnInit {

  /**
   * Output Variables
   * */

  @Output() timeFilterChange = new EventEmitter<TimeFilter>();

  /**
   * Input Variables
   */

  @Input() selectedValues: selectedValues = {
    selectedSection: 'Pilot',
    selectedPilot: null,
    selectedVehicle: null,
    selectedBattery: null,
    timeFilter: {
      selectedFilter: 'months',
      selectedNumberOfMonths: 1,
      selectedNumberOfYears: 1,
      selectedYear: new Date().getFullYear()
    }
  };

  /**
   * Child variables
   */

  @ViewChild(IonPopover) popover: IonPopover;

  /**
   * Local variables
   * */

  timeFilter: TimeFilter;

  numMonthsList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  numYearsList: number[] = [];
  yearList: number[] = [];

  private currentPopover = null;
  
  constructor(private popoverController: PopoverController) { }

  // #region --> Life Cycle Methods

  ngOnInit() {

    this.generateNumYearsList();

  }

  // #endregion --> Life Cycle Methods

  // #region --> Setting Data Methods

  /**
   * Generate a list of years from 2020 to the current year
   */
  generateNumYearsList() {
    const currentYear = new Date().getFullYear();
    const startYear = 2020;
    const numYears = currentYear - startYear + 1;
    this.numYearsList = Array.from({ length: numYears }, (_, i) => i + 1);
    this.yearList = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
  }

  /**
   * Reset the time filter values to the default values.
   */
  resetNumYears() {
    this.selectedValues.timeFilter.selectedFilter = 'months';
    this.selectedValues.timeFilter.selectedNumberOfMonths = 1;
    this.selectedValues.timeFilter.selectedNumberOfYears = 1;
    this.selectedValues.timeFilter.selectedYear = new Date().getFullYear();
  }

  // #endregion --> Setting Data Methods
  
  // #region --> Filter Methods

  /**
   * Emit the time filter values to the parent component.
   */
  applyFilter() {
    this.timeFilter = {
      selectedFilter: this.selectedValues.timeFilter.selectedFilter,
      selectedNumberOfMonths: this.selectedValues.timeFilter.selectedNumberOfMonths,
      selectedNumberOfYears: this.selectedValues.timeFilter.selectedNumberOfYears,
      selectedYear: this.selectedValues.timeFilter.selectedYear
    };

    this.timeFilterChange.emit(this.timeFilter);

  }

  applyFilterAndDismiss() {
    this.applyFilter();
    this.popover?.dismiss();
  }

  // #endregion --> Filter Methods

}

export interface TimeFilter {
  selectedFilter: 'months' | 'years';
  selectedNumberOfMonths: number;
  selectedNumberOfYears: number;
  selectedYear: number;
}